export const SOCIAL_LINKS = {
	x: "https://x.com/opencutapp",
	github: "https://github.com/OpenCut-app/OpenCut",
	discord: "https://discord.com/invite/Mu3acKZvCp",
};
